import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { environment } from 'src/environment';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationBar } from 'src/services/notification.service';

@Component({
  selector: 'app-competition-create',
  standalone: false,
  templateUrl: './competition-create.component.html',
  styleUrl: './competition-create.component.scss'
})
export class CompetitionCreateComponent {

  notificationBar: NotificationBar;
  competitionGroup = new FormGroup({
    nameControl: new FormControl('', [Validators.required]),
  });
  isProcessing = false;
  workspaceID = "";
  logoUploadProgress = 0;
  backgroundUploadProgress = 0;
  placeholderImage = environment.placeholderImage;

  constructor(private title: Title, private router: Router, private route: ActivatedRoute, private location: Location, private snackBar: MatSnackBar, private fireStorage: AngularFireStorage, private db: AngularFireDatabase) {
    this.notificationBar = new NotificationBar(snackBar);
   }
  
  ngOnInit() {  
    this.title.setTitle("New Competition - EsportsMS");
    this.route.paramMap.subscribe(params => {
      this.workspaceID  = this.location.path().split("/")[1];
    });
  }
  
  async createCompetition() {
    var competitionDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/competitions/');
    var newCompetitionRef = competitionDBRef.push();
    newCompetitionRef.set({
      'workspace': this.workspaceID,
      'name': this.competitionGroup.controls.nameControl.value,
      'active': true,
      'stage': "sbs",
    });
    this.router.navigate([ this.workspaceID + '/c/' + newCompetitionRef.key]);
    this.notificationBar.show("Competition created!")
  }
}
